export default "__VITE_ASSET__BWl$eqGx__"